import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Excel from "../../lease_management/assets/img/xlsx_icon.svg";
import Pdf from "../../lease_management/assets/img/pdf_icon.svg";
import Csv from "../../lease_management/assets/img/csv.png";
import { Button, CircularProgress, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import ButtonLoader from './ButtonLoader';
const ExportFileTypeComp = ({ handelExport,isLoading, isCsv, isPdf,isOnlyExcel }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const menuItemStyle = {
        py: 1,
        px: 2,
        borderRadius: "6px",
        width: '95px',
        padding: '3px 3px 3px 10px',
        mx: 0.5,
        fontSize: "14px",
        "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
        },
    };


    return (
        <>
            <Button disableRipple size='small' variant='outlined' onClick={(e) => {isOnlyExcel ? handelExport("xlsx") : setAnchorEl(e.currentTarget)}} color='primary' disabled={isLoading} startIcon={isOnlyExcel ? isLoading ? <ButtonLoader size={15} /> : <ArrowDownwardIcon /> :null}  endIcon={isOnlyExcel ? null :<ArrowDropDownIcon fontSize='small' />} className='btn-primary action-btn-start-icon'>Export</Button>
            <Menu elevation={3} anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)} >
                {isPdf===false? null:<MenuItem sx={menuItemStyle} onClick={() => { handelExport("pdf"); setAnchorEl(null); }}>
                    <ListItemIcon><img src={Pdf} alt="PDF" width={18} height={18} /></ListItemIcon>
                    <ListItemText primary="PDF" />
                </MenuItem>}
              
                <MenuItem sx={menuItemStyle} onClick={() => { handelExport("xlsx"); setAnchorEl(null); }}>
                    <ListItemIcon><img src={Excel} alt="Excel" width={18} height={18} /></ListItemIcon>
                    <ListItemText primary="Excel" />
                </MenuItem>
                {isCsv ?
                     <MenuItem sx={menuItemStyle} onClick={() => { handelExport("csv"); setAnchorEl(null); }}>
                    <ListItemIcon><img src={Csv} alt="CSV" width={18} height={18} /></ListItemIcon>
                    <ListItemText primary="CSV" />
                </MenuItem>:null
                }
            </Menu></>
    )
}
export default ExportFileTypeComp;